// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPassword_container__26eGO","header":"ResetPassword_header__2jSjX","body":"ResetPassword_body__1IaCZ","center":"ResetPassword_center__2SykA"};